import React from "react";
import ReactDOM from "react-dom/client";
import "normalize.css";
import "./index.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import App from "./App";
import { AppProvider } from "./context/appContext";
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
